import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        index: {type: Number, default: 0},
        threshold: {type: Number, default: 50}
    }

    touchStart(event) {
        this.startX = this.clientX(event)
    }

    touchEnd(event) {
        this.endX = this.clientX(event)

        this.swipe()
    }

    swipe() {
        if (this.isValidSwipe()) this.navigateBasedOnSwipe

        this.clearTouch()
    }

    // private

    clientX(event) {
        return event.changedTouches ? event.changedTouches[0].clientX : event.clientX
    }

    isValidSwipe() {
        return Math.abs(this.swipeDistance) >= this.thresholdValue
    }

    clearTouch() {
        this.startX = null
        this.endX = null
    }

    get navigateBasedOnSwipe() {
        this.swipeDistance > 0 ? this.previous() : this.next()
    }

    get swipeDistance() {
        return this.endX - this.startX
    }
}